import { render, staticRenderFns } from "./agendaSuratKeluar.vue?vue&type=template&id=17563f49&"
import script from "./agendaSuratKeluar.vue?vue&type=script&lang=js&"
export * from "./agendaSuratKeluar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QMenu,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QMenu,QDialog,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
